export default "__VITE_ASSET__BGKqztaZ__"